import {mapValues,isPlainObject,keys,values,isArray,isObject,isEqual,isString,isEmpty,transform,merge,forOwn} from 'lodash'

import Vue from 'vue'

window.Vue=Vue;//для доступа из контекста createFunByEval

export function generateid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}

/**
 * @param integer number: some integer
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 */
export function numberFormat(number,lenghtOfDecimal, lenghtOfWholePart, sectionDelimiter, decimalDelimiter) {
   var re = '\\d(?=(\\d{' + (lenghtOfWholePart || 3) + '})+' + (lenghtOfDecimal > 0 ? '\\D' : '$') + ')',
   num = number.toFixed(Math.max(0, ~~lenghtOfDecimal));
   return (decimalDelimiter ? num.replace('.', decimalDelimiter) : num).replace(new RegExp(re, 'g'), '$&' + (sectionDelimiter || ','));

  //12345678.9.format(2, 3, '.', ',');  // "12.345.678,90"
  //123456.789.format(4, 4, ' ', ':');  // "12 3456:7890"
  //12345678.9.format(0, 3, '-');       // "12-345-679"
};



export const mapValuesDeep = (obj, fn) =>
  mapValues(obj, (val, key) =>
    isPlainObject(val)
      ? mapValuesDeep(val, fn)
      : isArray(val)?val.forEach(e=>mapValuesDeep(e,fn)):fn(val, key, obj)
  );

export const deepCloneWithPath = (obj,customizer,path='') =>{

  const changeOnValue = customizer(obj,path);
  if (changeOnValue!=undefined) return changeOnValue;

  if (obj === null || typeof(obj) !== 'object' || 'isActiveClone' in obj)
    return obj;

  if (obj instanceof Date)
    var temp = new obj.constructor(); //or new Date(obj);
  else
    var temp = obj.constructor();

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      obj['isActiveClone'] = null;
      temp[key] = deepCloneWithPath(obj[key],path?path+'.'+key:key);
      delete obj['isActiveClone'];
    }
  }

  return temp;
}

export const mapValuesDeepPromise = (obj, fn) =>{
  const promises = [];
  mapValuesDeep(obj,(val, key, obj)=>{
    const result =  fn(val, key, obj);
    if(isPromise(result)) promises.push(result);
  });
  return promises;
};
/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
export const difference = (object, base) => {
  function changes(object, base) {
    return transform(object, function(result, value, key) {
      if (!isEqual(value, base[key])) {
        result[key] = (isObject(value) && isObject(base[key])) ? changes(value, base[key]) : value;
      }
    });
  }
  return changes(object, base);
};

export const isPromise = (obj)=>{
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
};

export const forOwnWithPath = (obj,callback,path='') =>{
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      if (!callback(path?path+"."+key:key,obj[key],key,obj) && (typeof(obj[key]) == 'object'))
        forOwnWithPath(obj[key],callback,path?path+"."+key:key)
    }
  }
}

export const tryTransformIfEval = (v,evalContext={})=>{
  if (isString(v)) return transformStrByEval(v,evalContext);
  if (isArray(v)) return v.map(e=>tryTransformIfEval(e,evalContext))
  if (isObject(v)) {
    const result = {}
    forOwn(v,(value,key)=>result[key]=tryTransformIfEval(value,evalContext))
    return result;
  }
  return v;
}

export const transformArrayByEval = (srcArray,obj,evalContext={})=>{
  return srcArray.map((e,index)=>createObjectByEval(obj,merge(evalContext,{"e":e,"elementIndex":index})))
};

export const createObjectByEval = (obj,evalContext={})=>{
  if (isString(obj)) return transformStrByEval(obj,evalContext);
  const newObj = obj.constructor();
  Object.keys(obj).forEach(key=>{
    newObj[key]=isString(obj[key])?transformStrByEval(obj[key],evalContext):isObject(obj[key])?createObjectByEval(obj[key],evalContext):obj[key];
  });
  return newObj;
};

export const transformStrByEval = (str,evalContext)=>{
  const reqExp = /{[^}]*[^{]*}/g;
  let s = str.trim();
  //if (s.startsWith("'") && s.endsWith("'")) s=s.substring(1,s.length-1)
  let match = s.match(reqExp);
  return match && match.length===1 && match==s?//test для строки типа {eval}
    invokeEval(s.substring(1,s.length-1),evalContext)://возвращаем результат выражения
    s.replace(reqExp,(t)=>invokeEval(t.substring(1,t.length-1),evalContext))//результат преобразуем в строку
};

export const invokeEval=(evalStr,evalContext) => {
  return  new Function(keys(evalContext), 'return '+evalStr).apply(null,values(evalContext));
};

//-----------------------------------------------------------

export const createFunForObjPropsByEval = (obj,paramNames) =>{
  const newObj = {};
  Object.keys(obj).forEach(key=>{
    newObj[key]=isString(obj[key])?tryTransformStrToFunByEval(obj[key],paramNames):isObject(obj[key])?createFunForObjPropsByEval(obj[key],paramNames):obj[key];
  });
  return newObj;
}

export const tryTransformStrToFunByEval = (testEval,paramNames) => {
  const v = testEval;
  return isString(v)&&v.trim().startsWith("{")&&v.trim().endsWith("}")
    ?createFunByEval(v.substring(1,v.length-1),paramNames):v;
}

export const createFunByEval = (evalStr, paramNames) =>{
  return  new Function(keys(evalContext), 'return '+evalStr);
}

// colores usados por Google en sus graficos, trends, etc.
export function colores_google(n) {
  const colores_g = ["#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", "#0099c6", "#dd4477", "#66aa00", "#b82e2e", "#316395", "#994499", "#22aa99", "#aaaa11", "#6633cc", "#e67300", "#8b0707", "#651067", "#329262", "#5574a6", "#3b3eac"];
  return colores_g[n % colores_g.length];
}

export function hashCode(str) {
  let hash = 0, i, chr;
  if (str.length === 0) return hash;
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + chr;
    hash |= 0;
  }
  return hash < 0 ? -hash : hash;
}

export function hex2rgb(hex) {
  hex = (hex + '').trim();

  let match = hex.match(/^#?(([0-9a-zA-Z]{3}){1,3})$/);

  if (!match) {
    return null;
  }

  let rgb = {};

  hex = match[1];

  if (hex.length === 6) {
    rgb.r = parseInt(hex.substring(0, 2), 16);
    rgb.g = parseInt(hex.substring(2, 4), 16);
    rgb.b = parseInt(hex.substring(4, 6), 16);
  }
  else if (hex.length === 3) {
    rgb.r = parseInt(hex.substring(0, 1) + hex.substring(0, 1), 16);
    rgb.g = parseInt(hex.substring(1, 2) + hex.substring(1, 2), 16);
    rgb.b = parseInt(hex.substring(2, 3) + hex.substring(2, 3), 16);
  }

  return rgb;
}

export const computeWindowRangeWithBounds = (startTime,endTime,boundsX,boundsY)=>{
  const deltaT = boundsY.width/boundsX.width*(endTime-startTime);
  const startTimeY = Math.round((boundsY.left-boundsX.left)/boundsY.width * deltaT + startTime);
  const endTimeY = Math.round(startTimeY+deltaT);
  return [startTimeY,endTimeY]
}


